export var SignatureStatus;
(function (SignatureStatus) {
    SignatureStatus["REQUESTED"] = "requested";
    SignatureStatus["REJECTED"] = "rejected";
    SignatureStatus["CONFIRMED"] = "confirmed";
})(SignatureStatus || (SignatureStatus = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["STARTED"] = "started";
    TransactionStatus["REJECTED"] = "rejected";
    TransactionStatus["BROADCASTED"] = "broadcasted";
})(TransactionStatus || (TransactionStatus = {}));
//# sourceMappingURL=events.js.map